const trackingUtils = require('od-modules/utils/tracking.utils');
const svgHelper = require('od-modules/helpers/svg_manager');
const handlerWaitingPage = require('od-modules/handlers/dpresults/waiting_page');
const TRANSLATIONS = Odigeo.UIElements.translations.dynpackProduct.waiting;
const animationData = {
    duration: 5000,
    queue: null,
    changeInterval: null,
};
const $page = $('#page');
const oSerializer = new XMLSerializer();
const dpWaitingSvg = ['hotel', 'airplane', 'credential_vacations', 'skeleton'];
let svgContent = {
    airplane: '',
    hotel: '',
    credential_vacations: '',
};

function togglePrimeDayCountdown(toggle) {
    $('#campaign_countdown_dp_results_accommodation').toggleClass('odf-hidden', toggle);
    $('#campaign_countdown_dp_results_accommodation_details').toggleClass('odf-hidden', toggle);
}

function initializeWaitingPage(opts) {
    this.animation.delay = new Date().getTime();
    this.$cachedSelectors.container.show().addClass('animated');
    handlerWaitingPage.triggerVisibility(true);
    setAdvertisement.call(this, opts.adv);
    trackingWaitingPage(opts.analytics);
}

function setAdvertisement(hasAdv) {
    if (hasAdv) {
        Odigeo.UIElements.enhanceAdvertisementGptNonJS(this.$el.find('.dpwaiting_page').find('#modwaiting'));
    }
}

function trackingWaitingPage(index) {
    const funnel = Odigeo.Utils.getFunnelInGlobalScope();
    const suffix = Odigeo.Session.get('payment3ds') === 'true' ? '-3dsecure' : `/${index}`;

    trackingUtils.trackPage(`waiting${suffix}`, {
        legacy: `/waitPage/paso${index}/${funnel}/`,
        funnel: true,
    });

    Odigeo.Session.set('payment3ds', false);
}

function computeSvgStyles(shape, name) {
    const fixFooterHeight = 140;
    const brandHeaderHeight = $('.header').height();
    const heightSvg = parseInt(shape.getAttribute('height'), 10);
    const viewPortCorrection = ($(window).height() - fixFooterHeight - brandHeaderHeight - heightSvg) / 2;
    const width = parseInt(shape.getAttribute('width'), 10);
    const heightCorrection = heightSvg + viewPortCorrection;
    const viewbox = `0 -${viewPortCorrection} ${width} ${heightCorrection}`;

    shape.setAttribute('viewBox', viewbox);
    shape.setAttribute('height', heightCorrection);
    shape.setAttribute('width', '100%');
    shape.setAttribute('class', `od-waitings-svg-${name}`);
}

function getSvgImages() {
    const hasSvgImages = Odigeo._.every(svgContent, Odigeo._.negate(Odigeo._.isEmpty));

    if (hasSvgImages) {
        startAnimation.call(this);
    } else {
        svgHelper.getSvgImages(
            svgContent,
            (...args) => this.onFetchError(...args),
            (...args) => this.onFetchSuccess(...args),
            () => this.onFetchAllSuccess()
        );
    }
}

function startAnimation() {
    const $animationContainer = this.$el.find(this.selectors.animation);
    const $stepsTextWrapper = this.$el.find(this.selectors.stepsTextWrapper);

    this.animation.svgSequence = Odigeo._.clone(dpWaitingSvg);
    insertAnimation.call(this, $animationContainer, $stepsTextWrapper);
    animationData.changeInterval = setInterval(() => {
        insertAnimation.call(this, $animationContainer, $stepsTextWrapper);
    }, animationData.duration);
}

function stopAnimation() {
    clearInterval(animationData.changeInterval);
}

function insertAnimation($svgContainer, $textContainer) {
    const key = this.animation.svgSequence.shift();

    if (key === 'skeleton') {
        this.activateSkeletonPage();
    } else {
        $svgContainer.html(svgContent[key]);
        $textContainer.html(TRANSLATIONS[key]);
    }

    if (Odigeo._.isEmpty(this.animation.svgSequence)) {
        stopAnimation();
    }
}

module.exports = Odigeo.View.extend({
    animation: {
        delay: 0,
        svgSequence: [],
    },
    selectors: {
        container: '#dpwaitingpage-container',
        animation: '.swiper_svg_wrapper',
        stepsTextWrapper: '.swiper_text_wrapper',
        stepsErrorWrapper: '.swiper_error_wrapper',
        header: 'header',
    },
    tmpls: {
        main: '#waitingpage-template',
    },
    init() {
        this.tmpls = Odigeo.Utils.getTemplates(this.$el, this.tmpls);
        this.opts = Odigeo.Utils.parseOptions(this.widget.options);
    },
    activateWaitingPage(fullData = {}) {
        let waitingOptions;

        Odigeo.trigger(`${this.widget.id}:hidePageOverDpWaitingPage`);
        waitingOptions = this.model.initWaitingPage(fullData);
        this.$cachedSelectors.container.hide();
        this.renderTemplate('#waiting-', waitingOptions);
        initializeWaitingPage.call(this, waitingOptions);
        if (this.opts.hasSvgAnimation) {
            getSvgImages.call(this);
        }
        togglePrimeDayCountdown(true);
        return this;
    },
    renderTemplate(templateId, waitingOptions) {
        const selectedPage = this.model.get('selectedPage');
        const selectedConfig = this.model.get(selectedPage);
        const $subTemplate = this.$el.find(templateId + selectedConfig.id);

        if ($subTemplate.length > 0) {
            $page.find('.dpresults_common_header').addClass('odf-hidden');
            this.$cachedSelectors.container.html(this.tmpls.main(Odigeo._.extend({
                renderContainer: Odigeo._.template($subTemplate.html(), Odigeo.Utils.getTmplSettings()),
            }, waitingOptions)));
        }
    },
    activateSkeletonPage() {
        this.renderTemplate('#waiting-skeleton-');
        Odigeo.trigger(`${this.widget.id}:activateSkeletonPage`, true);
    },
    getCalculatedDelay() {
        if (this.opts.hasSvgAnimation) {
            return 0;
        } else {
            const minimumIntervalTime = 3000;
            const minimumTimeLoading = 1500;

            return (new Date().getTime() - this.animation.delay) < minimumIntervalTime ? minimumTimeLoading : 0;
        }
    },
    animateWaiting(animationCb, delay) {
        if ($.fx.muted) {
            this.activateContent(Odigeo._.noop);
            this.$cachedSelectors.container.hide();
            this.cleanWaitingPage(Odigeo._.noop);
        } else {
            this.$cachedSelectors.container
                .clearQueue()
                .delay(delay)
                .queue(Odigeo._.bind(this.activateContent, this))
                .queue(Odigeo._.bind(animationCb, this))
                .queue(Odigeo._.bind(this.cleanWaitingPage, this));
        }
    },
    activateContent(next) {
        Odigeo.trigger(`${this.widget.id}:cleanDpWaitingPage`);
        next();
    },
    deactivateWaitingPage(next) {
        this.$cachedSelectors.container.removeClass('animated');
        next();
    },
    offWaitingPage(next) {
        this.$cachedSelectors.container.hide();
        next();
    },
    cleanWaitingPage(next) {
        if (this.opts.hasSvgAnimation) {
            stopAnimation();
        }
        this.animation.delay = 0;
        this.$cachedSelectors.container.empty();
        handlerWaitingPage.triggerVisibility();
        $page.find('.dpresults_common_header').removeClass('odf-hidden');
        togglePrimeDayCountdown(false);
        next();
    },
    onFetchSuccess(data, name) {
        const shape = data.getElementsByTagName('svg')[0];

        computeSvgStyles(shape, name);
        svgContent[name] = oSerializer.serializeToString(shape);
    },
    onFetchAllSuccess() {
        startAnimation.call(this);
    },
    onFetchError() {
        this.$el.find(this.selectors.stepsErrorWrapper).removeClass('odf-hidden');
    },
});
